
import { formatTimezoneOffset, getTimezoneDisplayName } from './timezone-detection';

// Generate dynamic timezone options with current offsets
const generateTimezones = () => {
  const timezoneData = [
    { value: "Pacific/Kwajalein", region: "International Date Line West" },
    { value: "Pacific/Samoa", region: "Samoa" },
    { value: "Pacific/Honolulu", region: "Hawaii" },
    { value: "America/Anchorage", region: "Alaska" },
    { value: "America/Los_Angeles", region: "Pacific Time (US & Canada)" },
    { value: "America/Denver", region: "Mountain Time (US & Canada)" },
    { value: "America/Chicago", region: "Central Time (US & Canada)" },
    { value: "America/New_York", region: "Eastern Time (US & Canada)" },
    { value: "America/Halifax", region: "Atlantic Time (Canada)" },
    { value: "America/Sao_Paulo", region: "São Paulo, Brazil" },
    { value: "Atlantic/South_Georgia", region: "South Georgia" },
    { value: "Atlantic/Azores", region: "Azores" },
    { value: "Europe/London", region: "London, Dublin, Edinburgh" },
    { value: "Europe/Paris", region: "Paris, Berlin, Rome" },
    { value: "Europe/Athens", region: "Athens, Cairo" },
    { value: "Europe/Moscow", region: "Moscow, Baghdad" },
    { value: "Asia/Dubai", region: "Dubai, Abu Dhabi" },
    { value: "Asia/Karachi", region: "Islamabad, Karachi" },
    { value: "Asia/Kolkata", region: "New Delhi, Mumbai" },
    { value: "Asia/Dhaka", region: "Dhaka, Astana" },
    { value: "Asia/Bangkok", region: "Bangkok, Hanoi" },
    { value: "Asia/Shanghai", region: "Beijing, Singapore" },
    { value: "Asia/Tokyo", region: "Tokyo, Seoul" },
    { value: "Australia/Sydney", region: "Sydney, Melbourne" },
    { value: "Pacific/Noumea", region: "New Caledonia" },
    { value: "Pacific/Auckland", region: "Auckland, Wellington" },
  ];

  return timezoneData.map(tz => {
    const displayName = getTimezoneDisplayName(tz.value);
    const offset = formatTimezoneOffset(tz.value);
    return {
      value: tz.value,
      label: `${displayName} (${offset})`
    };
  });
};

export const timezones = generateTimezones();

export const languages = [
  { value: "en", label: "English" },
  { value: "zh", label: "中文 (Chinese)" },
  { value: "es", label: "Español (Spanish)" },
  { value: "fr", label: "Français (French)" },
  { value: "de", label: "Deutsch (German)" },
  { value: "ja", label: "日本語 (Japanese)" },
  { value: "ko", label: "한국어 (Korean)" },
  { value: "pt", label: "Português (Portuguese)" },
  { value: "ru", label: "Русский (Russian)" },
  { value: "ar", label: "العربية (Arabic)" },
];

// Use standard format values for database storage
export const sessionFormats = [
  { value: "in_person", label: "In Person" },
  { value: "virtual", label: "Virtual" },
];

export const currencies = [
  { value: "USD", label: "美元 USD ($)" },
  { value: "EUR", label: "欧元 EUR (€)" },
  { value: "JPY", label: "日元 JPY (¥)" },
  { value: "GBP", label: "英镑 GBP (£)" },
  { value: "CNY", label: "人民币 CNY (¥)" },
  { value: "CHF", label: "瑞士法郎 CHF" },
  { value: "CAD", label: "加拿大元 CAD (C$)" },
  { value: "AUD", label: "澳大利亚元 AUD (A$)" },
  { value: "SGD", label: "新加坡元 SGD (S$)" },
  { value: "NZD", label: "新西兰元 NZD (NZ$)" },
  { value: "HKD", label: "港币 HKD (HK$)" },
  { value: "SEK", label: "瑞典克朗 SEK (kr)" },
  { value: "NOK", label: "挪威克朗 NOK (kr)" },
  { value: "DKK", label: "丹麦克朗 DKK (kr)" },
  { value: "MXN", label: "墨西哥比索 MXN ($)" },
];
